module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-no"
  }, [_vm._v("Praise for Michele Clark McConnochie")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Very well written in concise language and divided into 63 chapters of 2/3 pages each. You can pick it up and read for ten minutes then come back, but you won’t—it is too exciting for that. Believable fantasy and behind it all is a sharp sense of humour that even adults will appreciate. A book that demands to be read aloud to children from 8—13 years old.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Bob Docherty, Bob’s Books, NZ")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("An imaginative and light-hearted fantasy adventure novel that has bags of energy, humour and originality. This is a book to be enjoyed by children aged 9-12, as well as their parents. 85%.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("The Book Reviewers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Sagas continue to be extremely well written with delightful animal characters that show real passion for the love of them! These books show compassionate love of fellow man, too, with a great mystery and goal involved! Easy to read, too, with short chapters which is great for children! Can hardly wait for the final Saga!")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Pete & Peggy, Amazon 5* Review")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The funniest part of the book is how the group manages to get themselves kidnapped by goblins and how they escape using an uncooperative but accommodating flying carpet.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Gauri Bhandari, NZ Booklovers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I’m pleased this is the first book in a series because I really enjoyed reading it. It made me laugh a lot. Even though I hadn’t met Sabrina before in other books, I felt like I knew her pretty quickly. I’m not saying which fairy tales get touched upon in this book because that’s a fun part of the story. There is a good mix of humour, great peril, sibling disagreement, and some aww moments too. It’s gone on my digital reread bookshelf!")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Nayu’s Reading Corner")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-417e2834","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 57
// module chunks = 0